// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_al-0";
export var headerCellHover = "_al-1";
export var readCellContainer = "_al-2";
export var readCellSlot = "_al-3";
export var rowHoverCheckbox = "_al-4";
export var rowUnreadIndicator = "_al-5";
export var searchHighlight = "_al-8";
export var summaryCellHoverWrapper = "_al-9";
export var supportTicketRow = "_al-6";
export var unreadIndicator = "_al-7";